export { ConfirmationPage } from './confirmation-page';
